import React, { useContext } from 'react';
import moment from 'moment';
import cn from 'classnames';
import config from '../../config';
import style from './style.css';
import { FlowContext } from '../../core/flow-engine';

const FooterSite = () => {
  const { flowProps } = useContext(FlowContext);
  const { displayStickyBanner } = flowProps || {};
  return (
    <div
      className={cn('footer-site', { 'no-margin-top': displayStickyBanner })}
      data-metrics-location="FTR">
      <div className="top-content">
        <div>
          <div className="trp-mission">
            INVEST WITH CONFIDENCE
            <sup>®</sup>
          </div>
          <hr aria-hidden="true" className="tag-line" />
        </div>
        <div className="footer-sub-header">
          We’re driven by our purpose: To identify and actively invest in
          opportunities to help people thrive in an evolving world.
        </div>
        <div className="links">
          <div className="corp">
            <div className="corp-title">Company</div>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}corporate/us/en/what-we-do.html`}
              rel="noopener noreferrer"
              target="_blank">
              Company Overview
            </a>
            <a
              href={`${config('returnUrlPrefix')}corporate/en/careers.html`}
              rel="noopener noreferrer"
              target="_blank">
              Careers
            </a>
            <a
              href={`${config('returnUrlPrefix')}corporate/en/press.html`}
              rel="noopener noreferrer"
              target="_blank">
              Newsroom
            </a>
            <a
              href="https://troweprice.gcs-web.com/"
              rel="noopener noreferrer"
              target="_blank">
              Investor Relations
            </a>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}corporate/en/what-sets-us-apart/corporate-responsibility.html`}
              rel="noopener noreferrer"
              target="_blank">
              Responsibility
            </a>
          </div>
          <div className="corp">
            <div className="corp-title">Privacy & Legal</div>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}enterprise/legal/us/en/privacy-notices.html`}
              rel="noopener noreferrer"
              target="_blank">
              U.S. and Cananda Privacy Notice
            </a>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}personal-investing/help/policies-and-security/terms-of-use.html`}
              rel="noopener noreferrer"
              target="_blank">
              Terms of Use
            </a>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}personal-investing/help/policies-and-security/security.html`}
              rel="noopener noreferrer"
              target="_blank">
              Security Measures
            </a>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}personal-investing/help/policies-and-security/legal.html`}
              rel="noopener noreferrer"
              target="_blank">
              Legal Information
            </a>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}personal-investing/about-t-rowe-price/form-crs.html`}
              rel="noopener noreferrer"
              target="_blank">
              Form CRS
            </a>
            <a
              href={`${config('returnUrlPrefix')}en/us/accessibility`}
              rel="noopener noreferrer"
              target="_blank">
              Accessibility Statement
            </a>
          </div>
          <div className="corp">
            <div className="corp-title">Personal Investing</div>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}personal-investing/sitemap.html`}
              rel="noopener noreferrer"
              target="_blank">
              Site Map
            </a>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}corporate/en/mobile-solutions.html`}
              rel="noopener noreferrer"
              target="_blank">
              Mobile App
            </a>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}personal-investing/help/contact/index.html`}
              rel="noopener noreferrer"
              target="_blank">
              Contact Us
            </a>
            <a
              href={`${config(
                'returnUrlPrefix'
              )}personal-investing/help/policies-and-security/customer-agreement.html`}
              rel="noopener noreferrer"
              target="_blank">
              Customer Agreement
            </a>
            <a
              href={`${config('returnUrlPrefix')}en/us/glossary`}
              rel="noopener noreferrer"
              target="_blank">
              Glossary
            </a>
            <a
              href={`${config('returnUrlPrefix')}en/us/market-data-disclosures`}
              rel="noopener noreferrer"
              target="_blank">
              Market Data Disclosure
            </a>
          </div>
        </div>
        <div className="social-media">
          <div className="">Find us on:</div>
          <a
            className="icon icon-fb"
            href="https://www.facebook.com/troweprice"
            rel="noopener noreferrer"
            target="_blank">
            Facebook
          </a>
          <a
            className="icon icon-tw"
            href="https://twitter.com/troweprice"
            rel="noopener noreferrer"
            target="_blank">
            X
          </a>
          <a
            className="icon icon-yt"
            href="http://www.youtube.com/trowepricegroup"
            rel="noopener noreferrer"
            target="_blank">
            YouTube
          </a>
          <a
            className="icon icon-ln"
            href="http://www.linkedin.com/company/157329?trk=tyah"
            rel="noopener noreferrer"
            target="_blank">
            LinkedIn
          </a>
          <a
            className="icon icon-insta"
            href="https://www.instagram.com/t._rowe_price"
            rel="noopener noreferrer"
            target="_blank">
            Instagram
          </a>
        </div>
      </div>
      <div className="content bottom-content">
        <div className="wrapper">
          <div>
            <div className="share-personalinfo">
              <button
                type="button"
                id="oneTrustConsentPrefences"
                className="ot-sdk-show-settings">
                Do Not Sell or Share My Personal Information
              </button>
            </div>
            The funds referred to in this website are offered and sold only to
            persons residing in the United States and are offered by prospectus
            only. The prospectuses include investment objectives, risks, fees,
            expenses, and other information that you should read and consider
            carefully before investing. T. Rowe Price Investment Services, Inc.,
            distributor, T. Rowe Price mutual funds and T. Rowe Price ETFs.
            <div className="disclosure-text">
              Download a{' '}
              <a
                href={`${config(
                  'returnUrlPrefix'
                )}personal-investing/funds/mutual-funds/prospectuses-reports.html`}
                target="_blank"
                rel="noreferrer noopener">
                mutual fund prospectus
              </a>
              <span> or </span>
              <a
                href={`${config(
                  'returnUrlPrefix'
                )}personal-investing/funds/etfs/prospectuses-reports.html`}
                target="_blank"
                rel="noreferrer noopener">
                ETF prospectus.
              </a>
            </div>
          </div>
          <div>
            &copy;{moment().format('YYYY')}. All Rights Reserved. T. ROWE PRICE,
            INVEST WITH CONFIDENCE, and the Bighorn Sheep design are trademarks
            of T. ROWE PRICE Group, Inc. All other trademarks are the property
            of their respective owners. User does not imply endorsement,
            sponsorship, or affiliation of T. Rowe Price with any of the
            trademark owners.
          </div>
        </div>
      </div>

      <style jsx>{style}</style>
    </div>
  );
};

export default FooterSite;
